import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import getClassNames from 'src/common/utils/getClassNames';
import { Breadcrumb } from 'src/common/types/api/v4/boats/search';
import Icon from 'src/common/components/IconDS22';
import classNames from 'classnames';
import Typography from 'src/common/components/Typography';
import DlpBreadcrumbs from 'src/search/components/DlpBreadcrumbs';
import styles from './LocationSummary.module.scss';

export type LocationSummaryProps = {
  rating?: number;
  numberOfReviews?: number;
  breadcrumbs: Breadcrumb[];
  noResults: boolean;
};

/** Ratings, Reviews, and Breadcrumbs */
const LocationSummary: FC<LocationSummaryProps> = ({
  rating,
  numberOfReviews,
  breadcrumbs,
  noResults,
}) => {
  const [t] = useTranslation('search-page');

  return (
    <div className={getClassNames(styles, 'root', classNames({ noResults }))}>
      {!!numberOfReviews && numberOfReviews > 0 && (
        <>
          <Icon
            id="star-filled"
            size="s"
            className={styles.icon}
          />
          <Typography
            type="span"
            size="body-m"
            weight="semibold"
          >
            {rating?.toFixed(1)}
            {' '}
          </Typography>
          <div
            className={styles.reviews}
          >
            <Typography
              type="span"
              size="body-m"
            >
              {'('}
              {t('breadcrumbs--reviews', {
                numberOfReviews: numberOfReviews.toLocaleString(),
                count: numberOfReviews,
              })}
              {')'}
            </Typography>
          </div>
        </>
      )}
      <DlpBreadcrumbs
        breadcrumbs={breadcrumbs}
        iconSize="m"
        separator=", "
        typographySize="body-m"
      />
    </div>
  );
};

export default LocationSummary;
